import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ className = "" }) {
  const { resolved, toggle } = useTheme();
  const isDark = resolved === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle-button"
      aria-label={isDark ? "Aktifkan mode terang" : "Aktifkan mode gelap"}
      title={isDark ? "Mode terang" : "Mode gelap"}
      className={`relative h-9 w-9 rounded-lg border border-border bg-card flex items-center justify-center hover:bg-secondary/60 transition-colors ${className}`}
    >
      <Sun className={`h-[18px] w-[18px] absolute transition-all duration-200 ${isDark ? "opacity-0 -rotate-90 scale-75" : "opacity-100 rotate-0 scale-100"}`} />
      <Moon className={`h-[18px] w-[18px] absolute transition-all duration-200 ${isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-75"}`} />
    </button>
  );
}
